import { ControlRecord, IOwnerProfileSession, ISessionSettings } from '../ts/Definitions';
import Database from '../utilities/database';
import Settings from './settings';
import Cookies from '../utilities/cookies';
import ConfigCache from '../utilities/ConfigCache';
import { ProfileRole } from '../ts/enums';
import { NotificationType } from './messaging';

export default class ProfileSettings extends Settings {
    private settingsUpdatedCallback: ((settings: ISessionSettings) => void) | undefined;
    constructor(database: Database,
        ownerProfileUserId: string,
        settings: ISessionSettings,
        ownerProfileSummary: IOwnerProfileSession,
        systemSettings: ISessionSettings | undefined,
        configCache: ConfigCache,
        cookies: Cookies,
        settingsUpdatedCallback?: (settings: ISessionSettings) => void) {
        super(database,
            () => ({}),
            cookies,
            ownerProfileUserId, configCache);
        this.settingsUpdatedCallback = settingsUpdatedCallback;
        this.settings = settings;
        this.systemSettings = systemSettings;
        this.memberOwnerProfileSummary = ownerProfileSummary;
        this.setAwaitingOwnerSettings(false);
        this.setAwaitingControl(false);
        void this.initialise(ownerProfileUserId);
    }

    // eslint-disable-next-line
    public async updateSettings(settings: ISessionSettings, systemUpdate?: boolean): Promise<boolean> {
        if (this.isSystemSettings()) {
            return super.updateSettings(settings, systemUpdate);
        }
        if (!this.memberOwnerProfileSummary) {
            this.showMessage({ message: 'Unable to find profile to update settings, please contact admin', error: true, persist: true, notificationType: NotificationType.ErrorInfo });
            return false;
        }
        this.saveOwnerProfileSettings(this.memberOwnerProfileSummary, settings);
        this.settings = settings; // this profile mimics the settings of a user for an owner.
        if (this.settingsUpdatedCallback) this.settingsUpdatedCallback(settings);
        return true;
    }

    public canUpdateNewItems = (): boolean => {
        return true;
    }

    public isAdmin = () => {
        return true;
    }

    public getMemberCommunityProfile(user: ControlRecord): ControlRecord {
        if (!user) return user;
        const role = this.getCommunityRole(user, []);
        return new ControlRecord({
            ...user,
            role: role,
        });
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public getCommunityRole = (_user: ControlRecord, _profiles: IOwnerProfileSession[]): ProfileRole => {
        return ProfileRole.Owner;
    }
}